import { render, staticRenderFns } from "./PetAndProjectRecursiveComments.vue?vue&type=template&id=70a501a9&scoped=true&"
import script from "./PetAndProjectRecursiveComments.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectRecursiveComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a501a9",
  null
  
)

export default component.exports